import { Department, Job } from '@/features/careers/v2/types'
import { Article } from '@/features/careers/v1/components/Vacancies/types'

export const getDepartmentsFromJobs = (jobs: Job[]): Department[] =>
  jobs
    .map((job) => job.department)
    .filter((dept): dept is Department => Boolean(dept))

export const findJobById = (jobs: Job[], id: string) =>
  jobs.find((job) => job.id.toString() === id)

export const mapJobsToArticles = (jobs: Job[], articles: Article[]) =>
  articles
    .map(({ id, url }) => {
      const job = findJobById(jobs, id)
      return job ? { ...job, url } : undefined
    })
    .filter(Boolean) as (Job & { url: string })[]

export const addJobCountToDepartments = <TJob extends Job>(jobs: TJob[]) =>
  getDepartmentsFromJobs(jobs).map((department) => ({
    ...department,
    count: jobs.reduce(
      (prev, curr) => prev + (curr.department?.id === department?.id ? 1 : 0),
      0,
    ),
  }))

export const filterJobsByDepartments = <TJob extends Job>(
  jobs: TJob[],
  departmentIds: number[],
) => {
  // No department filter, return all jobs
  if (!departmentIds.length) {
    return jobs
  }

  return jobs.filter((job) =>
    job.department ? departmentIds.includes(job.department.id) : false,
  )
}

export const filterJobsByLocations = <TJob extends Job>(
  jobs: TJob[],
  locationNames: string[],
) => {
  // No location filter, return all jobs
  if (!locationNames.length) {
    return jobs
  }

  return jobs.filter(
    (job) => !!job.location?.name && locationNames.includes(job.location.name),
  )
}
